import { render, staticRenderFns } from "./ActivityLingos.vue?vue&type=template&id=12032ef1&scoped=true"
import script from "./ActivityLingos.vue?vue&type=script&lang=ts"
export * from "./ActivityLingos.vue?vue&type=script&lang=ts"
import style0 from "./ActivityLingos.vue?vue&type=style&index=0&id=12032ef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12032ef1",
  null
  
)

export default component.exports